import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/creators/{creatorId}/creditors/{creditorId}']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getCreatorCreditor = async ({ creatorId, creditorId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/creators/{creatorId}/creditors/{creditorId}', { creatorId, creditorId });
  const data = await noodleApiClient.get(path);
  return data.data;
};

export default getCreatorCreditor;
